import { RhFormGroup, RhFormGroupItem, RhInputFormik } from "@rhythm-ui/react";
import React from "react";

interface RadioInputType {
  name: string;
  options: { value: string; label: string }[];
  alignment?: "Vertical" | "Horizontal";
  className?: string;
}

const RadioInputFormik = ({
  name,
  options,
  alignment = "Vertical",
  className,
}: RadioInputType) => {
  return (
    <div className={`${className ?? ""}`}>
      <RhFormGroup
        className={
          alignment !== "Vertical"
            ? `flex-wrap gap-tnano md:gap-tm2`
            : "flex-col gap-tpico"
        }
      >
        {/* <div className="flex flex-wrap justify-between"> */}
        {options.map((option: { value: string; label: string }) => (
          <RhFormGroupItem
            key={option.value}
            control={
              <RhInputFormik
                type="radio"
                data-testid={`RhFormGroupItem-${option.label}`}
                className="m-tnano"
                value={option.value}
                name={name}
              />
            }
            className="text-primary-gray [&>div]:flex [&>div]:items-center"
            label={option.label}
          />
        ))}
        {/* </div> */}
      </RhFormGroup>
    </div>
  );
};

export default RadioInputFormik;
